/*
creditcard-date

usage:
test a date against to be valid for a creditCard transaction

return:
 Boolean

*/
function isStringOrNumber(t) {
	return typeof t === 'string' || typeof t === 'number';
}

function containsOnlyDigits(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	const nums = new RegExp(/^\+?[0-9]+$/);
	return nums.test(str);
}

function isValidCountryCode(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	return Boolean(containsOnlyDigits(str) && str.length > 0 && str.length < 4);
}

function isValidPhoneNumber(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	return Boolean(containsOnlyDigits(str) && str.length > 5 && str.length < 13);
}

function isValidDKCountryCode(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	return Boolean(containsOnlyDigits(str) && str === '45');
}

function isValidDKPhoneNumber(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	return Boolean(containsOnlyDigits(str) && str.length === 8);
}

export { isValidPhoneNumber, isValidCountryCode, isValidDKCountryCode, isValidDKPhoneNumber };
